"use strict";

angular.module('app.controllers.accessRequests', []).config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('access', {
        parent: 'site',
        url: '/access',
        templateUrl: 'views/CustomActions/accessrequests.html',
        controller: 'AccessRequestsCtrl',
        breadcrumb: {
            initialState: true,
            name: 'NAV_AccessRequest'
        },
        infoGuide : {
            state: 'accessRequests'
        }
    });
}]).controller("AccessRequestsCtrl", [
    '$scope',
    '$rootScope',
    'f_Info',

    'API',
    'viewMenuBarService',
    '__DatapointValue',
    'xCenterConfig',
    'f_User',
    'appConfig',
    'dateTimePickerModal',

    function ($scope, $rootScope, f_Info, API, viewMenuBarService, __DatapointValue, xCenterConfig, f_User,appConfig,dateTimePickerModal) {
        $scope.isLocal = appConfig().isLocal;
        var _API = new API();
        $scope.init = function () {
            // MasterService.refreshNavigationByReload('accessRequests', 'accessRequests');
            viewMenuBarService.setButtons({});
            viewMenuBarService.setFavorite(false);

            // Get remote Control Eabled value from API.

            var d = [{
                "$type": "BMS.Shared.DatapointCore.DatapointValue`1[[System.Boolean, mscorlib]], BMS.Shared",
                "DatapointConfigId": "4af0c89a-f6ec-43a5-8175-79f0c8accfef",
                "DeviceId": "00000000-0000-0000-0000-000000000000"
            }];
            // Remote control.Value == true   list[0].Value == 0;


            __DatapointValue.$collection(d).$refresh().$then(function (response) {
                if (response[0].Value == true) {
                    if (xCenterConfig.interval.accessRequestCheck <= 0) {
                        return
                    }
                    ;
                    var count;

                    if (!f_User.getUserLevel() || f_User.getUserLevel() == 0) {
                        return false
                    }
                    ;


                    _API.Portal.GetAccessPrincipals().$promise.then(function (response) {
                        var count = 0;
                        if (response && response.length > 0) {

                            for (var i = 0; i < response.length; i++) {
                                if (response[i].State == 1) {
                                    count++;
                                }
                            }
                        }
                        $scope.AccessRequests = response;
                        $scope.accessRequestCounter = count;
                        $rootScope.$broadcast('access-request-update',{count:count});

                    });
                } else {
                    f_Info.addInfo(
                        {
                            'TitleTranslated': 'ACCESS_RemoteControlConnectedDisabled_Title',
                            'DisplayTextTranslated': 'ACCESS_RemoteControlConnectedDisabled_Text'
                        })
                }
            });


        }
        $scope.init();


        $scope.acceptRequest = function (request) {

            request.State = 2;
            $scope.saveRequest(request);

        }

        $scope.rejectRequest = function (request) {
            request.State = 3;
            $scope.saveRequest(request);
        }

        $scope.resetDateFor = function (p, model) {
            p['temp_' + model] = '';
        }
        $scope.setDateFor = function (p, model) {
            if ($scope.isLocal) {
                if (p[model] != undefined) {
                    if (p['temp_' + model]) {
                        var m = new moment(p['temp_' + model]);
                    } else {
                        m = new moment(p[model]);
                    }

                } else {
                    m = new moment();
                }
                var mom = moment();
                // datePikcerModal
                dateTimePickerModal(m.format(),{after: new moment(),filter:function(day){ return day.isAfter(mom); }}).then(function(modal){
                    modal.close.then(function(data){

                        if(data){
                            p['temp_' + model] = moment( data ) .utc().format().replace('+00:00','Z');
                        }
                    })
                })
               //$rootScope.pickADate =
                /*$scope.pickADateListener = $scope.$on('pickADate', function (event, args) {
                    console.log(args);
                    if (model) {
                         = $rootScope.pickADate.model
                    }
                    $rootScope.pickADate = undefined;
                    $scope.pickADateListener();

                });*/
            }

        }
        $scope.resetDateFor = function (p, model) {
            if ($scope.isLocal) {
                p['temp_' + model] = undefined;
                $scope.saveDateFor(p, model);
            }

        }
        $scope.clearDateFor = function (p, model) {
            if ($scope.isLocal) {
                p['temp_' + model] = undefined;
            }

        }
        $scope.saveDateFor = function (p, model) {
            if ($scope.isLocal) {
                $scope.$emit('loading-start');
                if (p.State == 2) {
                    var accepted = true;
                } else {
                    accepted = false;
                }

                p[model] = p['temp_' + model];
                var validUntil = p.ValidUntil ? new moment(p.ValidUntil).utc().format().replace('+00:00','Z') : null;
                var validFrom = p.ValidFrom ? new moment(p.ValidFrom).utc().format().replace('+00:00','Z') : null;

                var o = {
                    "PrincipalResponse": {

                        'AccountId': p.AccountId,
                        'Accepted': accepted,
                        'ValidFrom': validFrom,
                        'ValidUntil':validUntil
                    }
                };
                o.PrincipalResponse[model] = p['temp_' + model];

                _API.Portal.SetAccessPrincipal(
                        o
                    )
                    .$promise
                    .then(function () {
                        $rootScope.loading = false;
                        p[model] = p['temp_' + model];
                        p['temp_' + model] = null;
                        p.sub = true;
                        $scope.init();
                        $scope.$emit('loading-stop');

                    }, function () {
                        $scope.$emit('loading-stop');
                    });
            }

        }

        $scope.toggleRequest = function (request) {

            if (request.State == 2) {
                request.State = 3;
            } else {
                request.State = 2;
            }
            $scope.saveRequest(request);
        }

        $scope.saveRequest = function (request) {
            if (request.State == 2) {
                var accepted = true;
            } else {
                accepted = false;
            }

            _API.Portal.SetAccessPrincipal({
                "PrincipalResponse": {

                    'AccountId': request.AccountId,
                    'Accepted': accepted,
                    'ValidFrom': request.ValidFrom,
                    'ValidUntil': request.ValidUntil
                }
            }).$promise.then(function (response) {
                $scope.init();
            })
        }

    }
]);
